export const msalConfig = {
  auth: {
    clientId: "aeb75cb9-570b-4ab4-b73a-4fa40c1d0fb1",
    authority: "https://login.microsoftonline.com/e8cd81ca-449c-4567-a821-802b14854e27",
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
};

export const APPROVERS = [
  "kfinlaw@lakeco.com",
  "dpoynter@lakeco.com",
  "mlandrie@lakeco.com",
  "mmeeuwsen@lakeco.com",
];

export const MILEAGE_RATE = 0.76; // IRS rate effective July 1, 2026

export const CATEGORIES = [
  "Meals",
  "Mileage",
  "Lodging",
  "Transportation",
  "Airfare",
  "Office Supplies",
  "Other",
];
